import { useEffect, useState } from 'react';

import { AddressWithBbrId } from '~src/model';
import { formatAddress } from '~src/util';

import { Coordinates } from './types';
import { fetchGeolocationCoordinates } from './util';

export const useGeolocationLookup = (inputAddress?: Partial<AddressWithBbrId>) => {
  const [coordinates, setCoordinates] = useState<Coordinates>({});

  // Callers pass a new object on every render; only a different address should trigger a lookup.
  const addressKey = inputAddress ? `${inputAddress.id ?? ''}|${formatAddress(inputAddress)}` : undefined;

  useEffect(
    function getCoordinatesFromAddress() {
      if (!inputAddress) {
        return;
      }

      const controller = new AbortController();

      fetchGeolocationCoordinates(inputAddress, { signal: controller.signal })
        .then(({ latitude, longitude } = {}) => {
          if (controller.signal.aborted || !longitude || !latitude) {
            return;
          }

          setCoordinates(() => ({ latitude, longitude }));
        })
        // The map stays without a centre when the address provider is unavailable.
        .catch(() => undefined);

      return () => controller.abort();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [addressKey]
  );

  return coordinates;
};
